import { useNavigate } from 'react-router-dom';
import Checkbox from '../../components/checkbox/checkbox';
import styles from './serviceLocationStep.module.css';

export default function ServiceLocationStep ({ formData, setFormData }) {
  const navigate = useNavigate();

  const validate = (currentOptions) => {
    let isValid = false;
    currentOptions.forEach((option) => {
      if (option.isChecked) {
        isValid = true;
      }
    });
    return isValid;
  };

  const handleChange = (checkboxOptions) => {
    // Update form
    setFormData((prevData) => ({
      ...prevData,
      locationStep: {
        locations: checkboxOptions,
        isValid: validate(checkboxOptions)
      }
    }));

    // Update url params
    const searchParams = new URLSearchParams(window.location.search);
    const checkedBoxes = checkboxOptions.filter(
      (checkbox) => checkbox.isChecked === true
    );
    const newParam = checkedBoxes.map((box) => box.value);

    if (newParam.length > 0) {
      searchParams.set('l', newParam);
    } else {
      searchParams.delete('l');
    }
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  return (
    <div className={styles.pageContainer}>
      <h2 className={styles.mobileH2}>
        {formData.providerStep.provider === 'registered'
          ? 'Where do you deliver your services?'
          : 'Where do you intend to deliver services?'}
      </h2>
      <p style={{ color: '#5B6770', textAlign: 'center', marginTop: '12px' }}>
        We collect this information to better understand who is using this tool.
      </p>
      <p style={{ color: '#313131', marginTop: '12px' }}>
        Select all that apply
      </p>
      <Checkbox
        hasSelectAll
        options={formData.locationStep.locations}
        handleChange={handleChange}
      />
    </div>
  );
}
